import React from "react";

const BS5_Home = () => {
  return (
    <div className="container mt-4">
      <h2>BS5_Home Component</h2>
      <p>This is the BS5_Home component for Bootstrap 5 tutorial.</p>
    </div>
  );
};

export default BS5_Home;
